import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Tables from "layouts/tables";
import { useState } from "react";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { hasActionAccess } from "utility";
import { useSelector } from "react-redux";
import {
  useGetServicePackagesQuery,
  useDeleteServicePackageMutation,
  useUpdateServicePackageMutation,
} from "slices/beautyApp/servicePackageSlice";
import Swal from "sweetalert2";

function ServicePackages() {
  const naviagte = useNavigate();
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [del] = useDeleteServicePackageMutation();
  const auth = useSelector((state) => state.auth.auth?.user);
  const [update] = useUpdateServicePackageMutation();

  const { data, isLoading, refetch } = useGetServicePackagesQuery({
    page,
    limit,
    search,
  });

  const col = [
    { display: "Name", key: "name", type: "display" },
    {
      display: "Image",
      key: "image",
      type: "image",
      style: { width: "100px", height: "100px", borderRadius: "20%" },
    },
    { display: "Total Price", key: "totalPrice", type: "display" },
    {
      display: "Status",
      key: "isAvailable",
      type: "display",
      render: (row) => (
        <input
          type="checkbox"
          checked={row.isAvailable === true}
          onChange={() => handleStatusToggle(row._id, !row.isAvailable)}
          style={{
            width: "18px",
            height: "18px",
            accentColor: row.isAvailable ? "green" : "red",
            cursor: "pointer",
          }}
        />
      ),
    },
  ];

  const canEdit = hasActionAccess(
    auth,
    "Beauty App",
    "Service Packages",
    "edit"
  );

  const canDelete = hasActionAccess(
    auth,
    "Beauty App",
    "Service Packages",
    "delete"
  );

  if (canEdit || canDelete) {
    col.push({
      display: "Actions",
      key: "edit",
      type: "action",
      render: (row, onEdit, handleDelete) => (
        <>
          {canEdit && <Button onClick={() => onEdit(row)}>Edit</Button>}
          {canDelete && (
            <Button onClick={() => handleDelete(row._id)}>Delete</Button>
          )}
        </>
      ),
    });
  }

  const handleStatusToggle = async (id, newStatus) => {
    try {
      let response = await update({
        id,
        body: { isAvailable: newStatus },
      }).unwrap();

      if (response) {
        refetch();
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err?.message || "Error updating status",
      });
    }
  };

  const handleSearchChange = (value) => {
    setSearch(value);
    setPage(1);
  };

  const changePage = (newPage, newLimit) => {
    const apiPage = newPage + 1; // MUI is 0-based, API is 1-based
    setPage(apiPage);
    setLimit(newLimit);
  };

  const onEdit = (row) => {
    naviagte(`/beauty-app/service-packages/update-service-package/${row._id}`, {
      state: { refresh: true },
    });
  };

  const handleAdd = () => {
    naviagte("/beauty-app/service-packages/add-service-package", {
      state: { refresh: true },
    });
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this package?")) {
      await del(id).unwrap();
      refetch();
    }
  };

  const canAdd = hasActionAccess(auth, "Beauty App", "Service Packages", "add");

  return (
    <DashboardLayout>
      <DashboardNavbar />

      {canAdd && (
        <Button onClick={handleAdd} style={{ background: "#fff" }}>
          Add Package
        </Button>
      )}

      <Tables
        title={"Packages"}
        handleSearch={handleSearchChange}
        totalPages={data?.page}
        data={data?.data}
        columns={col}
        changePage={changePage}
        onEdit={onEdit}
        handleDelete={handleDelete}
        currentPage={page} // ✅ pass to control current pagination
        rowsPerPage={limit}
      />
      <Footer />
    </DashboardLayout>
  );
}

export default ServicePackages;
